var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWallet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.898 7.523a.75.75 0 0 0 0 1.5h4.474a.75.75 0 0 0 0-1.5H7.898ZM16.767 10.925a.75.75 0 0 0 0 1.5h.258a.75.75 0 0 0 0-1.5h-.258Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 13.956v.853a5.099 5.099 0 0 1-5.099 5.098H8.488A5.099 5.099 0 0 1 3.39 14.81V8.86a5.099 5.099 0 0 1 5.1-5.1h7.162a5.099 5.099 0 0 1 5.1 5.1v5.095ZM8.488 5.262A3.599 3.599 0 0 0 4.89 8.86v5.947a3.599 3.599 0 0 0 3.6 3.6h7.162a3.599 3.599 0 0 0 3.6-3.6v-.102h-2.606a2.982 2.982 0 0 1-2.98-2.98 2.982 2.982 0 0 1 2.98-2.98h2.603a3.6 3.6 0 0 0-3.597-3.484H8.488Zm8.158 7.944h2.604v-2.96h-2.604a1.481 1.481 0 1 0 0 2.96Z",
    fill: "#fff"
  })));
};
export default SvgWallet;